// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yaiOP","largestCol":"styles_largestCol__2TcPR","smallestCol":"styles_smallestCol__iiewJ"};